module.exports = __webpack_public_path__ + "static/media/fk.aeb2d588.svg";